import ActionTypes from '@utils/deviceActions';

const simCardModels = (actionKey?: ActionTypes, isMotBusiness?: boolean) => {
  switch (actionKey) {
    case ActionTypes.ACTIVATION_MULTI_CONNECT:
      return ['iccid'];
    case ActionTypes.ACTIVATION_MOT:
      return ['vendor', 'iccid', 'msisdn', 'imsi'];
    case ActionTypes.MANUAL_ACTIVATION:
    case ActionTypes.SUSPENSION:
    case ActionTypes.WITHDRAWAL_OF_SUSPENSION:
    case ActionTypes.CANCELLATION_SUSPENSION:
    case ActionTypes.FORCE_REACTIVATION:
    case ActionTypes.NETWORK_RESET:
    case ActionTypes.CONTRACT_SUSPEND:
    case ActionTypes.PROVISIONAL_WITHDRAW:
    case ActionTypes.SMS_BLOCK:
    case ActionTypes.SMS_UNBLOCK:
    case ActionTypes.BROKER_CANCELLATION:
    case ActionTypes.BROKER_CANCELLATION_WAIVER:
    case ActionTypes.BROKER_SUBSTITUTION:
    case ActionTypes.HLR_REPROG:
    case ActionTypes.IMEI_UNLOCK:
    case ActionTypes.BAIT_RENEWAL:
    case ActionTypes.SYNC_APN:
    case ActionTypes.CANCELLATION:
      return ['msisdn'];
    case ActionTypes.SIMCARD_RESET:
    case ActionTypes.PRIORITY_OPERATOR:
    case ActionTypes.OPERATOR_RESTRICTION:
      return ['msisdn', 'iccid'];
    case ActionTypes.NETWORK_BLOCK:
      return [
        'msisdn',
        'blockType:blockingType',
        'blockStartDate:blockingInitialDate',
        'blockEndDate:blockingFinalDate',
      ];
    case ActionTypes.NETWORK_UNLOCK:
      return ['msisdn', 'unlockDate:processData'];
    case ActionTypes.NICKNAME_CHANGE:
      return ['msisdn', 'iccid', 'newNickname:processData'];
    case ActionTypes.TRANSFER:
      return [
        'msisdn',
        'iccid',
        `${
          isMotBusiness ? 'groupingId' : 'requestId'
        }:newCustomerVirtualAccountId`,
      ];
    case ActionTypes.PLASTIC_EXCHANGE:
      return ['msisdn', 'iccid', 'newIccid:processData'];
    case ActionTypes.CHANGE_SIMCARD:
      return ['iccid', 'newIccid:processData'];
    case ActionTypes.MOT_DEACTIVATION:
      return ['msisdn', 'iccid'];
    case ActionTypes.MSISDN_EXCHANGE:
      return ['iccid', 'msisdn', 'newMsisdn:processData'];
    case ActionTypes.ADD_CREDIT_TO_SIMCARD:
    case ActionTypes.CREDIT_PURCHASE:
      return ['msisdn', 'value:processData', 'unit'];
    case ActionTypes.IMEI_LOCK:
      return ['msisdn', 'imei:processData'];
    case ActionTypes.FINANCIAL_UNLOCK:
    case ActionTypes.FINANCIAL_LOCK:
      return ['customerId'];
    case ActionTypes.MOT_OPERATOR_CHANGE:
      return ['msisdn', 'newVendor:vendor'];
    case ActionTypes.CHANGE_APN:
      return ['msisdn', 'apn'];
    default:
      return [];
  }
};

export default simCardModels;
